<dx-button *ngIf="!isSmallScreen" stylingMode="text">
  <div
    #chatIconContainer
    id="chatIconContainer"
    class="cc-chat-icon-container"
  ></div>
</dx-button>
